import React from 'react'
import { Platform } from 'react-native'

import { B5, Icon, SH1 } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import { IBrandComsData } from '../../api/brands/types'

const Header = ({
  content,
  variantName,
  setIsBottomSheetVisible,
}: {
  variantName?: string
  content: IBrandComsData
  setIsBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const isWeb = Platform.OS === 'web'

  return (
    <XStack className="justify-between px-3 pb-2">
      <Stack className="flex-1">
        <SH1 className="text-start">{variantName || content?.name}</SH1>
        {!isWeb && (
          <B5>
            {i18n.t('recommendationBottomSheet.earnUpTo', {
              amount: content?.commission,
            })}
          </B5>
        )}
      </Stack>
      <Pressable onPress={() => setIsBottomSheetVisible(false)}>
        <Icon type="Close" />
      </Pressable>
    </XStack>
  )
}

export default Header
